// Map mã lỗi public (Spec §7.4 / CR-S2-2-5-001) sang copy tiếng Việt cho UI SCR-050.
// Backend giữ error code; UI chỉ diễn giải các mã đã công bố, không tự đoán nguyên nhân khác.

export type AdminCommandError = Readonly<{
  code: string;
  requestId?: string | undefined;
}>;

const DOMAIN_PREFIXES = ["ORGANIZATION_", "ADMIN_AREA_"] as const;

/**
 * Bỏ đúng prefix domain (ORGANIZATION_/ADMIN_AREA_) để tái dùng một bảng copy cho cả hai
 * domain. COMMON_* và mọi mã khác được giữ nguyên, không cắt theo dấu '_' đầu tiên.
 */
function normalizeCode(code: string): string {
  for (const prefix of DOMAIN_PREFIXES) {
    if (code.startsWith(prefix)) return code.slice(prefix.length);
  }
  return code;
}

export function describeAdminError(code: string): string {
  switch (normalizeCode(code)) {
    case "COMMON_VERSION_CONFLICT":
      return "Dữ liệu đã thay đổi, tải lại phiên bản mới";
    case "COMMON_IDEMPOTENCY_CONFLICT":
      return "Yêu cầu trùng khóa idempotency, tải lại phiên bản trước khi gửi lại";
    case "COMMON_FORBIDDEN_SCOPE":
      return "Bạn không có quyền với phạm vi dữ liệu này";
    case "COMMON_NOT_FOUND":
      return "Không tìm thấy dữ liệu";
    case "COMMON_VALIDATION_FAILED":
      return "Dữ liệu không hợp lệ";
    case "CODE_CONFLICT":
      return "Mã đã tồn tại trong hệ thống";
    case "NOT_FOUND":
      return "Không tìm thấy đối tượng";
    case "NOT_ACTIVE":
      return "Đơn vị không hoạt động tại thời điểm hiệu lực";
    case "PERIOD_INVALID":
    case "VERSION_OVERLAP":
      return "Ngày hiệu lực không hợp lệ với lịch sử phiên bản";
    case "DECISION_REFERENCE_INVALID":
      return "Mã căn cứ quyết định không hợp lệ";
    case "CYCLE":
    case "MERGE_DESCENDANT":
      return "Không thể chuyển đơn vị vào chính nó hoặc đơn vị con";
    case "MERGE_SELF":
      return "Không thể sáp nhập đơn vị vào chính nó";
    case "ALREADY_MERGED":
      return "Đơn vị đã được sáp nhập trước đó";
    case "CHILD_PERIOD_CONFLICT":
      return "Có đơn vị con không giao thời gian với ngày hiệu lực";
    case "NO_CHANGE":
      return "Không có thay đổi so với giá trị hiện tại";
    case "REFERENCED":
      return "Đối tượng đang được tham chiếu, chỉ được đóng hoặc sáp nhập";
    case "ROLE_ASSIGNMENT_TARGET_INACTIVE":
      return "Tài khoản đích không còn hoạt động nên không thể cấp vai trò";
    case "ROLE_ASSIGNMENT_SCOPE_INVALID":
      return "Phân quyền phải khai báo ít nhất một phạm vi hiệu lực";
    case "ROLE_ASSIGNMENT_NOT_ALLOWED":
      return "Danh mục quyền hiện hành không cho phép tổ hợp vai trò và phạm vi này";
    case "ROLE_ASSIGNMENT_PERIOD_INVALID":
      return "Thời điểm bắt đầu phải từ hiện tại và thời điểm kết thúc phải sau thời điểm bắt đầu";
    case "ROLE_ASSIGNMENT_OVERLAP":
      return "Tài khoản đã có phân quyền trùng vai trò và phạm vi trong khoảng thời gian này";
    case "ROLE_ASSIGNMENT_LAST_ADMIN_REQUIRED":
      return "Không thể thu hồi phân quyền quản trị đang hiệu lực cuối cùng";
    case "ROLE_ASSIGNMENT_REFERENCE_INVALID":
      return "Đơn vị hoặc địa bàn trong phạm vi không còn hiệu lực tại thời điểm phân quyền";
    default:
      return "Có lỗi xảy ra, vui lòng thử lại";
  }
}

export function isVersionConflict(code: string): boolean {
  return code === "COMMON_VERSION_CONFLICT" || code === "COMMON_IDEMPOTENCY_CONFLICT";
}
